 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLSS_US_ADULT_SIGNUP_FRONT from '@/components/xhtml/SS_US_adult_signup_front'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLDED from '@/components/xhtml/ded'
 import XHTMLPROLOGUE from '@/components/xhtml/prologue'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLCH08 from '@/components/xhtml/ch08'
 import XHTMLCH09 from '@/components/xhtml/ch09'
 import XHTMLCH010 from '@/components/xhtml/ch010'
 import XHTMLCH011 from '@/components/xhtml/ch011'
 import XHTMLCH012 from '@/components/xhtml/ch012'
 import XHTMLCH013 from '@/components/xhtml/ch013'
 import XHTMLCH014 from '@/components/xhtml/ch014'
 import XHTMLCH015 from '@/components/xhtml/ch015'
 import XHTMLCH016 from '@/components/xhtml/ch016'
 import XHTMLCH017 from '@/components/xhtml/ch017'
 import XHTMLCH018 from '@/components/xhtml/ch018'
 import XHTMLCH019 from '@/components/xhtml/ch019'
 import XHTMLCH020 from '@/components/xhtml/ch020'
 import XHTMLCH021 from '@/components/xhtml/ch021'
 import XHTMLCH022 from '@/components/xhtml/ch022'
 import XHTMLCH023 from '@/components/xhtml/ch023'
 import XHTMLCH024 from '@/components/xhtml/ch024'
 import XHTMLCH025 from '@/components/xhtml/ch025'
 import XHTMLCH026 from '@/components/xhtml/ch026'
 import XHTMLCH027 from '@/components/xhtml/ch027'
 import XHTMLCH028 from '@/components/xhtml/ch028'
 import XHTMLCH029 from '@/components/xhtml/ch029'
 import XHTMLCH030 from '@/components/xhtml/ch030'
 import XHTMLCH031 from '@/components/xhtml/ch031'
 import XHTMLCH032 from '@/components/xhtml/ch032'
 import XHTMLCH033 from '@/components/xhtml/ch033'
 import XHTMLCH034 from '@/components/xhtml/ch034'
 import XHTMLCH035 from '@/components/xhtml/ch035'
 import XHTMLCH036 from '@/components/xhtml/ch036'
 import XHTMLCH037 from '@/components/xhtml/ch037'
 import XHTMLCH038 from '@/components/xhtml/ch038'
 import XHTMLCH039 from '@/components/xhtml/ch039'
 import XHTMLCH040 from '@/components/xhtml/ch040'
 import XHTMLCH041 from '@/components/xhtml/ch041'
 import XHTMLCH042 from '@/components/xhtml/ch042'
 import XHTMLCH043 from '@/components/xhtml/ch043'
 import XHTMLCH044 from '@/components/xhtml/ch044'
 import XHTMLCH045 from '@/components/xhtml/ch045'
 import XHTMLCH046 from '@/components/xhtml/ch046'
 import XHTMLCH047 from '@/components/xhtml/ch047'
 import XHTMLCH048 from '@/components/xhtml/ch048'
 import XHTMLCH049 from '@/components/xhtml/ch049'
 import XHTMLCH050 from '@/components/xhtml/ch050'
 import XHTMLCH051 from '@/components/xhtml/ch051'
 import XHTMLCH052 from '@/components/xhtml/ch052'
 import XHTMLCH053 from '@/components/xhtml/ch053'
 import XHTMLCH054 from '@/components/xhtml/ch054'
 import XHTMLCH055 from '@/components/xhtml/ch055'
 import XHTMLCH056 from '@/components/xhtml/ch056'
 import XHTMLCH057 from '@/components/xhtml/ch057'
 import XHTMLCH058 from '@/components/xhtml/ch058'
 import XHTMLCH059 from '@/components/xhtml/ch059'
 import XHTMLCH060 from '@/components/xhtml/ch060'
 import XHTMLCH061 from '@/components/xhtml/ch061'
 import XHTMLCH062 from '@/components/xhtml/ch062'
 import XHTMLCH063 from '@/components/xhtml/ch063'
 import XHTMLCH064 from '@/components/xhtml/ch064'
 import XHTMLCH065 from '@/components/xhtml/ch065'
 import XHTMLCH066 from '@/components/xhtml/ch066'
 import XHTMLSS_RECOMMENDPAGE from '@/components/xhtml/SS_recommendpage'
 import TEASER_9781501151033XHTMLSS_TEASER_INTRO_9781501151033 from '@/components/teaser_9781501151033/xhtml/SS_teaser_intro_9781501151033'
 import TEASER_9781501151033XHTMLPROLOGUE_TEASER_9781501151033 from '@/components/teaser_9781501151033/xhtml/prologue_teaser_9781501151033'
 import TEASER_9781501151033XHTMLCH01_TEASER_9781501151033 from '@/components/teaser_9781501151033/xhtml/ch01_teaser_9781501151033'
 import TEASER_9781501151033XHTMLSS_TEASER_READMORE_9781501151033 from '@/components/teaser_9781501151033/xhtml/SS_teaser_readmore_9781501151033'
 import XHTMLAUTHOR from '@/components/xhtml/author'
 import XHTMLALSO from '@/components/xhtml/also'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLSS_US_ADULT_SIGNUP_BACK from '@/components/xhtml/SS_US_adult_signup_back'
 import XHTMLCOPY from '@/components/xhtml/copy'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cover",
 			"name" : "xhtml/cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/SS_US_adult_signup_front",
 			"name" : "xhtml/SS_US_adult_signup_front",
 			"component" : XHTMLSS_US_ADULT_SIGNUP_FRONT
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/title",
 			"name" : "xhtml/title",
 			"component" : XHTMLTITLE
 		},
 		{
 			"path" : "/xhtml/ded",
 			"name" : "xhtml/ded",
 			"component" : XHTMLDED
 		},
 		{
 			"path" : "/xhtml/prologue",
 			"name" : "xhtml/prologue",
 			"component" : XHTMLPROLOGUE
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
 		{
 			"path" : "/xhtml/ch02",
 			"name" : "xhtml/ch02",
 			"component" : XHTMLCH02
 		},
 		{
 			"path" : "/xhtml/ch03",
 			"name" : "xhtml/ch03",
 			"component" : XHTMLCH03
 		},
 		{
 			"path" : "/xhtml/ch04",
 			"name" : "xhtml/ch04",
 			"component" : XHTMLCH04
 		},
 		{
 			"path" : "/xhtml/ch05",
 			"name" : "xhtml/ch05",
 			"component" : XHTMLCH05
 		},
 		{
 			"path" : "/xhtml/ch06",
 			"name" : "xhtml/ch06",
 			"component" : XHTMLCH06
 		},
 		{
 			"path" : "/xhtml/ch07",
 			"name" : "xhtml/ch07",
 			"component" : XHTMLCH07
 		},
 		{
 			"path" : "/xhtml/ch08",
 			"name" : "xhtml/ch08",
 			"component" : XHTMLCH08
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js